module.exports = __webpack_public_path__ + "static/media/notification_sound.8fae87a8.mp3";